const breakpoints = {
  INITIAL: { value: 'INITIAL', min: 0, max: 0 },
  XS: { value: 'XS', min: 0, max: 320 },
  SM: { value: 'SM', min: 321, max: 600 },
  MD: { value: 'MD', min: 601, max: 960 },
  LG: { value: 'LG', min: 961, max: 1280 },
  XL: { value: 'XL', min: 1281, max: Infinity }
}

export default breakpoints
